export const getAccountIdByUrl = (url: string) => {
  const matches = /\/([a-z0-9-]*)\/(.*)/.exec(url);

  if (Array.isArray(matches) && matches[1]) {
    return matches[1];
  }

  return null;
};
